import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { HeaderWrapper, Heading, SubHeading, LinkWrapper, Link, HeadingText } from './styled';
import PortalCommunication from '../../helpers/portal-comms';

const LearningGapsModalHeader = (props) => {
  const { selectedClassRoom, selectedTopics } = useSelector(state => state.UPFAssignReducer);
  const { i18n } = props;

  const learningJourneys = useSelector(state => state.linkUpfModalReducer.learningJourneys);
  const studentIds = Object.keys(learningJourneys);

  const allLearningJourneys = studentIds.reduce((allLjs, studentId) => [...allLjs, ...learningJourneys[studentId]], []);

  const assessmentName = selectedTopics[0].assessmentName;
  const relatedCurriculum = selectedTopics[0]?.referenceCurriculum?.name;

  const loadUPFModule = () => {
    PortalCommunication.requestModuleChange(window._env_.upfAssignModuleId, window._env_.assessmentAssignModuleId);
  };

  return (
    <HeaderWrapper>
      <Heading>{i18n.t`Fill Learning Gaps`}</Heading>
      <SubHeading>{selectedClassRoom.label} - {assessmentName}</SubHeading>
      {relatedCurriculum && allLearningJourneys.length > 0 && <HeadingText>
        <strong>{i18n.t`Related Curriculum:`} </strong>
        {relatedCurriculum}
      </HeadingText>}
      <LinkWrapper>
        <Link onClick={loadUPFModule}>{i18n.t`Go to Understanding Practice and Fluency`}</Link>
      </LinkWrapper>
    </HeaderWrapper>
  );
};

LearningGapsModalHeader.propTypes = {
  i18n: PropTypes.object
};

export default LearningGapsModalHeader;
